import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api: AxiosInstance = axios.create({
  baseURL: API,
});

// Attach token from localStorage as fallback (for cross-site cookie issues)
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const t = localStorage.getItem("access_token");
  if (t) config.headers!.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err: unknown): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (!detail) return (err as { message?: string })?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e: { msg?: string }) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default api;